const useAuthSendEmailConfirmDto = async () => {
  const response = await useFetchData<FetchData>("/auth/send-email-confirm", {
    method: "POST",
  });

  return {
    ...response,
  };
};

export { useAuthSendEmailConfirmDto };
